// SuccessMessageCard.jsx
import React from "react";
import { Card, Button } from "../../common/utils/antd-imports/AntdImports";
import "./SuccessMessageCard.css";

const SuccessMessageCard = ({
  icon: Icon,
  header,
  infoText,
  buttonText,
  onButtonClick,
}) => {
  return (
    <Card className="success-message-card default-font">
      <div className="success-icon-container">{Icon && <Icon />}</div>
      {header && <div className="success-header">{header}</div>}
      <div className="success-info-text">{infoText}</div>
      {buttonText && (
        <Button
          type="primary"
          className="success-button default-background default-font"
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      )}
    </Card>
  );
};

export default SuccessMessageCard;
